import styled, { css } from 'styled-components';

// Victory renders its container div with an inline `touch-action: none`, which
// makes every chart a dead spot for scrolling on touch devices. The effective
// touch-action is the intersection down the ancestor chain, so a wrapper alone
// can't loosen it — the inline style has to be beaten with !important. None of
// our charts use a gesture-driven container (zoom/brush/voronoi), so `auto` is
// safe and also gives pinch-zoom back.
const allowTouchScroll = css`
  .VictoryContainer {
    touch-action: auto !important;
  }
`;

export const ChartContainer = styled.div`
  height: 320px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  ${allowTouchScroll}
`;

export const ChartOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 320px;
  z-index: 1;
  background: transparent;
  pointer-events: none;
`;

// For charts that aren't inside a ChartContainer. Don't use it within one:
// Victory's container is height: 100%, so it needs to stay a direct child of
// ChartContainer to resolve against its fixed height rather than overflowing.
export const ChartTouchArea = styled.div`
  ${allowTouchScroll}
`;
